export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';
export const INCREMENT_ALERT_INDEX = 'INCREMENT_ALERT_INDEX';
export const M_SET_ALERT = 'M_SET_ALERT';
export const M_RESET_ALERTS = 'M_RESET_ALERTS';
